"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createStyles = require("../styles/createStyles");
var _useTheme = require("../styles/useTheme");
var _HiddenProps = require("./HiddenProps");
const useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  const hidden = {
    display: 'none'
  };
  return theme.busbud.breakpoints.keys.reduce((acc, key) => {
    acc[(0, _HiddenProps.getBreakpointOnlyKey)(key)] = {
      [theme.busbud.breakpoints.only(key)]: hidden
    };
    acc[(0, _HiddenProps.getBreakpointUpKey)(key)] = {
      [theme.busbud.breakpoints.up(key)]: hidden
    };
    acc[(0, _HiddenProps.getBreakpointDownKey)(key)] = {
      [theme.busbud.breakpoints.down(key)]: hidden
    };
    return acc;
  }, {});
});

/**
 * @ignore - internal component.
 */
const HiddenCss = props => {
  const {
    children,
    className,
    only,
    component: Component = 'div'
  } = props;
  const theme = (0, _useTheme.useTheme)();
  const {
    classes,
    cx
  } = useStyles();
  const classesList = [];
  if (className) {
    classesList.push(className);
  }
  for (const breakpoint of theme.busbud.breakpoints.keys) {
    const breakpointUpKey = (0, _HiddenProps.getBreakpointUpKey)(breakpoint);
    const breakpointDownKey = (0, _HiddenProps.getBreakpointDownKey)(breakpoint);
    const breakpointUp = props[breakpointUpKey];
    const breakpointDown = props[breakpointDownKey];
    if (breakpointUp) {
      classesList.push(classes[breakpointUpKey]);
    }
    if (breakpointDown) {
      classesList.push(classes[breakpointDownKey]);
    }
  }
  if (only) {
    const onlyBreakpoints = Array.isArray(only) ? only : [only];
    onlyBreakpoints.forEach(breakpoint => {
      classesList.push(classes[(0, _HiddenProps.getBreakpointOnlyKey)(breakpoint)]);
    });
  }
  return /*#__PURE__*/_react.default.createElement(Component, {
    className: cx(classesList)
  }, children);
};
var _default = exports.default = HiddenCss;